import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function formatDateOrNA(value) {
    if (!value) {
        return 'N/A';
    }
    return new Date(value).toLocaleDateString(undefined, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });
}
function getDayDateDiff(startDate, endDate) {
    const oneDayMs = 1000 * 60 * 60 * 24;
    return Math.ceil((endDate.getTime() - startDate.getTime()) / oneDayMs);
}
/** Ported from fleet.js isExpired/isExpiring so this page matches the legacy vessel dialog's coloring rules. */
function isExpired(dateValue, subscriptionStatusId) {
    if (!dateValue) {
        return false;
    }
    return subscriptionStatusId === 2 || getDayDateDiff(new Date(), new Date(dateValue)) <= 0;
}
function isExpiring(dateValue) {
    if (!dateValue) {
        return false;
    }
    const dateDiff = getDayDateDiff(new Date(), new Date(dateValue));
    return dateDiff <= 30 && dateDiff > 0;
}
function getDaysRemaining(dateValue) {
    if (!dateValue) {
        return 0;
    }
    const dateDiff = getDayDateDiff(new Date(), new Date(dateValue));
    return dateDiff > 0 ? dateDiff : 0;
}
function getStatusBadge(dateValue, subscriptionStatusId, isTrial) {
    const trialSuffix = isTrial ? ' - Trial' : '';
    if (isExpired(dateValue, subscriptionStatusId)) {
        return { text: `Expired${trialSuffix}`, className: 'badge bg-danger' };
    }
    if (isExpiring(dateValue)) {
        return { text: `Expiring${trialSuffix}`, className: 'badge bg-warning text-dark' };
    }
    return { text: `Active${trialSuffix}`, className: 'badge bg-success' };
}
export function SubscriptionCard({ vessel }) {
    const onBoardStatus = getStatusBadge(vessel.SubscriptionExpiresOn, vessel.SubscriptionStatusID, vessel.IsTrial);
    const onlineStatus = getStatusBadge(vessel.WKOLicenseExpiresOn, 0, vessel.IsTrial);
    return (_jsxs("div", { className: "card shadow mb-3", children: [_jsx("h2", { className: "card-header", children: "Subscriptions" }), _jsxs("div", { className: "card-body", children: [_jsxs("div", { className: "row", children: [_jsxs("div", { className: "col-md-6 mb-3 mb-md-0", children: [_jsx("div", { className: "text-secondary mb-1", children: "On-board" }), _jsxs("div", { className: "d-flex flex-wrap align-items-center gap-2 mb-1", children: [_jsx("span", { className: onBoardStatus.className, children: onBoardStatus.text }), _jsxs("span", { children: ["Expires ", _jsx("span", { className: "fw-bold", children: formatDateOrNA(vessel.SubscriptionExpiresOn) })] }), _jsxs("span", { className: "text-secondary", children: ["\u00B7 ", getDaysRemaining(vessel.SubscriptionExpiresOn), " days remaining"] })] }), _jsxs("div", { className: "text-secondary", children: ["Issued ", _jsx("span", { children: formatDateOrNA(vessel.SubscriptionIssuedOn) })] })] }), _jsxs("div", { className: "col-md-6", children: [_jsx("div", { className: "text-secondary mb-1", children: "Online license" }), _jsxs("div", { className: "d-flex flex-wrap align-items-center gap-2 mb-1", children: [_jsx("span", { className: onlineStatus.className, children: onlineStatus.text }), _jsxs("span", { children: ["Expires ", _jsx("span", { className: "fw-bold", children: formatDateOrNA(vessel.WKOLicenseExpiresOn) })] }), _jsxs("span", { className: "text-secondary", children: ["\u00B7 ", getDaysRemaining(vessel.WKOLicenseExpiresOn), " days remaining"] })] })] })] }), vessel.LeftCompanyDate && (_jsx("div", { className: "row mt-3", children: _jsxs("div", { className: "col-12", children: ["Left Management on: ", _jsx("span", { className: "fw-bold", children: formatDateOrNA(vessel.LeftCompanyDate) })] }) }))] })] }));
}
